<script setup lang="ts">
/** [#e03fdbc2] Устройство в блоке «Какие устройства»: у каждого свой корпус и экран. Только картинка. */
import { ShieldCheck } from 'lucide-vue-next';
import { useNow } from './useNow';

defineProps<{ kind: string; label: string }>();

const { time } = useNow();
</script>

<template>
  <span class="dvc" :data-kind="kind" aria-hidden="true">
    <span class="dvc-screen">
      <i class="dvc-cam" />
      <b class="dvc-time">{{ time }}</b>
      <span class="dvc-status"><ShieldCheck />{{ label }}</span>
    </span>
  </span>
</template>
